import { Menu, Phone } from "lucide-react";
import { useState } from "react";

import { HEADER_CONFIG } from "@/shared/config/header.config";
import BrandLogo from "@/shared/layout/Header/BrandLogo";
import { getThemeComponentGroup } from "@/shared/lib/themeComponentClasses";

import HeaderAuthControl from "@/D2C/features/auth/components/HeaderAuthControl";
import { SiteDesktopNav } from "./SiteDesktopNav";
import { SiteMobileNav } from "./SiteMobileNav";

export function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const headerClasses = getThemeComponentGroup("header");
  const headerBgClass = headerClasses?.bgColor || "bg-theme-accent";
  const headerTextClass = headerClasses?.textColor || "text-theme-text";
  const phoneTextClass = headerClasses?.phoneTextColor || headerTextClass;
  const menuIconClass = headerClasses?.menuIconColor || headerTextClass;
  const loginButtonBgClass = headerClasses?.loginButtonBgColor || "bg-theme-accent";
  const loginButtonTextClass = headerClasses?.loginButtonTextColor || "text-theme-text";

  return (
    <header
      className={`sticky top-0 z-50 ${headerBgClass} ${headerTextClass} ${headerClasses?.root || ""}`}
    >
      <div className="mx-auto max-w-screen-xl px-4 md:px-6">
        <div className="flex h-[80px] items-center justify-between">
          <BrandLogo />

          <SiteDesktopNav />

          <div className="flex items-center gap-4">
            <a
              href={`tel:${HEADER_CONFIG.phone.value}`}
              className={`hidden items-center gap-2 text-base font-semibold lg:flex ${phoneTextClass}`}
            >
              <Phone className="h-5 w-5" />
              {HEADER_CONFIG.phone.label}
            </a>

            <button type="button" onClick={() => setMobileOpen(true)} className="p-2 lg:hidden">
              <Menu className={`h-6 w-6 ${menuIconClass}`} />
            </button>

            <HeaderAuthControl
              className="relative ml-4 hidden lg:block"
              loginButtonClassName={`inline-block rounded-lg px-4 py-2 font-semibold transition-colors hover:bg-theme-accent-hover ${loginButtonBgClass} ${loginButtonTextClass} ${headerClasses?.loginButton || ""}`}
            />
          </div>
        </div>
      </div>

      <HeaderAuthControl
        className="relative mt-2 px-4 lg:hidden"
        loginButtonClassName={`block w-full rounded-lg px-4 py-2 text-center font-semibold transition-colors hover:bg-theme-accent-hover ${loginButtonBgClass} ${loginButtonTextClass} ${headerClasses?.loginButton || ""}`}
      />

      <SiteMobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </header>
  );
}
